import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import React from 'react';
import { withRouter } from 'react-router-dom';
import styles from './style.module.less';

@withRouter
@BindAll()
export class ClausePrivacy extends React.Component {
  state = {
    countdown: null,
    disabled: false,
  };

  get isVisible() {
    return lodash.eq(lodash.get(this.$router.query, 'clause'), 'privacy')
  }

  initCountdown () {
    this.setState({
        disabled: true,
        countdown: Date.now() + 1000 * 6,
    })
  }

  hideModal = () => {
    this.$MergeQuery({clause: ''}, true)
    this.initCountdown()
  };

  componentDidUpdate(prevProps, prevState) {
    if(lodash.get(this.$router.query, 'clause') !== lodash.get(prevProps, 'location.query.clause')) {
        this.initCountdown()
    }
  }
  
  onCountdownFinish() {
    this.setState({disabled: false})
  }

  renderCountDown() {
    if(this.state.disabled) {
        return <div className={styles.countdown}>
            <span>确认(</span>
            <React.Antd.Countdown
              onFinish={this.onCountdownFinish}
              value={this.state.countdown}
              format="ss"
              suffix="s"
              key="countdown"
            />
            <span>)</span>
        </div>  
    }
    return <span>确认</span>
  }
  render() {
    return (
        <React.Antd.Modal
          title="隐私条款"
          visible={this.isVisible}
          onOk={this.hideModal}
          okText="确认"
          width={800}
          closable={false}
          footer={[
            <React.Antd.Button disabled={this.state.disabled} type='primary' key="ok" onClick={this.hideModal}>{this.renderCountDown()}</React.Antd.Button>
          ]}
        >
            <div className={styles.privacy}>
                <div className={styles.title}>隐私声明 </div>
                <p className={styles.notice}>本声明最后更新于 2021/6/18 </p>
                <div className={styles.theContent}>
                    <div className={styles.titleCont}>本声明适用范围</div>
                    <div className={styles.pCont}>
                        <p> <strong>联想Lenovo</strong>重视您的隐私。本隐私声明适用于通过由联想集团有限公司及其附属集团公司（下文简称“联想”）拥有和运营的网站以及由Lenovo或我们的服务提供商和合作伙伴维护的某些脱机服务收集的数据。本声明描述了Lenovo网站的信息处理方法，这些网站包括但不限于大联想伙伴网、chinabp.lenovo.com 、bp.lenovo.com、 www.lenovo.com、www.lenovo.com.cn、newsupport.lenovo.com.cn。本隐私声明描述了Lenovo网站的信息处理方法，包括收集何种信息、Lenovo如何使用此类信息以及用于什么目的；会同何人分享此类信息；以及Lenovo如何保护此类信息。它还介绍了您在使用、访问、更正和删除个人信息等方面的选项。此外，本声明还涉及Lenovo在某些脱机环境中（如营销、客户服务和支持）对个人信息的收集和使用。 </p>
                    </div>
                    <div className={styles.titleCont}>本声明不适用范围 </div>
                    <div className={styles.pCont}>
                        <p> Lenovo网站可能包含指向其他网站的链接，其中一些网站不归Lenovo所有或不受其控制。Lenovo不对这些其他网站的隐私做法或内容负责。我们的一些网页使用框架技术来显示供应商或合作伙伴的内容，同时保留我们网站的外观。此外，某些联想品牌网站由供应商或合作伙伴运营，如果标有“提供技术支持”徽标，则这些供应商和合作伙伴的隐私声明和使用条款将约束此类网站或体验。 </p>
                        <p>另请注意，本声明不适用于通过Lenovo产品、软件或其他来源收集的信息。</p>
                    </div>
                    <div className={styles.titleCont}>本声明的变更 </div>
                    <div className={styles.pCont}>
                        <p> 如果我们对本声明作出更改，我们会提供先前版本以便您了解更改的时间和内容。如果我们对本声明作出任何重大更改，会在该等更改生效之前通过在本网站发出通知或者发送电子邮件（发送至您帐户所指明的电子邮箱地址）的方式告知您。在适用数据保护法律的要求下，我们亦会就任何影响我们如何使用您个人信息的重大更改寻求您的同意。我们建议您定期查看本页面，以了解有关我们隐私做法的最新信息。  </p>
                        <p> Lenovo会收集哪些信息；如何使用这些信息；是否会与第三方分享任何个人信息？  </p>
                        <p> 当您与我们的网站以及由Lenovo或我们的服务提供商和合作伙伴维护的某些脱机服务互动时，Lenovo会收集有关您的信息。我们使用这些信息是为了向您提供您所请求的产品或服务；为您提供客户服务或支持；向您发送新闻、更新或优惠；改进我们的网站、产品和服务；确保他们表现最佳；以及其他原因。请注意，在某些情况下，如果您没有向我们提供我们要求的个人信息，我们可能无法向您提供您请求的产品、体验或功能。下面介绍了我们如何在某些联机和脱机环境中收集、使用和共享信息（包括个人信息）。   </p>
                    </div>
                    <div className={styles.titleCont}>浏览我们的网站</div>
                    <div className={styles.pCont}>
                        <p> 一般而言，如果您只是访问我们的网站而没有注册或登录，则您可以浏览我们的网站，而不提供除我们的 Web 服务器自动收集的非个人身份信息以外的任何其他信息。我们的 Web 服务器日志会自动收集我们网站访客的域名和某些相关数据（如 IP 地址或设备标识符）。此信息用于测量访问次数、花在Lenovo网站上的平均时间、浏览的页面和网站使用情况信息。我们使用这些信息来满足法律或法规要求；维护我们网站的安全性和完整性；衡量我们网站的使用情况；改进我们网站的内容；以及显示和通知广告。这些信息不会以使我们能够直接识别网站访客的形式保留或使用。我们可能会使用 Cookie 收集这些信息，如下面的“Lenovo是否会将 Cookie、标签、网络信标、分析和相关技术用于在线广告和其他用途？”一节所述。这些信息可能会与Lenovo的服务提供商共享，包括第三方数据托管、数据处理和网站服务，以便他们可以支持我们网站的功能、安全性、完整性和改进。  </p>
                        <p> Lenovo还基于用户在购买产品或服务时、促销期间提供给我们的信息以及来自调查和我们的服务器日志文件的信息，对我们用户的人口特征（例如年龄和性别）、兴趣和行为开展调查。我们这样做的目的是为了更好地了解您并为您提供服务。此类调查将以汇总的方式进行整理和分析，以防止识别与任何个人相关的个人信息。Lenovo有时可能会用第三方提供的信息补充这些信息。Lenovo可能会与我们的供应商分享这些汇总数据，使他们能够为Lenovo提供数据托管、处理、分析及相关服务。  </p>
                    </div>
                    <div className={styles.titleCont}>您的用户个人资料 </div>
                    <div className={styles.pCont}>
                        <p> 您的用户个人资料可能包含您在与Lenovo互动时提供的信息，包括个人信息，例如您对我们网站某些区域的使用；您的 Lenovo ID、MyAccount、护照帐户；您与我们的客户服务代表的联系；Lenovo产品/服务注册信息；以及来自您使用的某些Lenovo产品和/或服务的信息。您的用户配置文件允许 Lenovo：  </p>
                        <ul>
                            <li>为某些Lenovo产品和服务提供其正常工作所需的信息 </li>
                            <li>解决您可能遇到的Lenovo产品、服务或网站的问题； </li>
                            <li>建议让Lenovo产品、服务和我们的网站更好地工作的方法；  </li>
                            <li>为您提供有关Lenovo产品和服务的新闻、更新和信息；以及</li>
                            <li>如果您选择接收营销通讯，则为您提供您可能感兴趣的其他Lenovo产品或服务的相关信息。 </li>
                        </ul>
                        <p className={styles.strong}>以下各节将进一步详细介绍用户个人资料中可能包含的信息类型、Lenovo如何使用此类信息、是否会与任何第三方分享此类信息以及您可能做出的有关此类信息的某些选择。有关您的用户个人资料中可能包含的其他信息类型的更多详情，请参阅产品的Lenovo隐私声明。 </p>
                        <p className={styles.strong}>用户注册号或Lenovo ID 和Lenovo产品注册  </p>
                        <p >当您选择创建用户注册号或Lenovo ID、注册Lenovo产品或通过 MyAccount 或“护照”创建帐户时，我们将收集有关您和您的Lenovo产品的信息，包括个人信息。我们使用您的注册号或 Lenovo ID 以及相关的注册和帐户信息来识别您的身份，包括您何时使用我们的某些软件应用程序（如 Lenovo Vantage）和我们的交互式服务（如我们的在线商店和客户支持网站）。  </p>
                        <p >如果您选择创建一个注册号或Lenovo ID或注册您的产品/服务，我们将需要从您那里收集某些信息，例如您的姓名、地址、电子邮箱地址、语言、地区/国家、产品类型/型号、产品序列号、产品注册日期、您所在公司的法定代表人的身份证信息，以及有关您操作系统的激活数据。对于收集的法定代表人身份证信息，我们仅作为核查公司注册信息的真实有效性之用途；对于其他收集的信息，我们将使用这些信息来管理您的帐户或个人资料；提供您请求的服务；并向您提供通讯，包括您选择从Lenovo接收的营销消息。Lenovo出于此目的收集和保留的信息可能会与我们的服务提供商分享，以便他们可以向Lenovo及代表其提供数据托管、处理和营销服务。   </p>
                        <p>
                            您可以通过登陆注册号或者访问 account.lenovo.com 并导航至“我的个人资料”来更改您的注册号或者密码。
                        </p>
                    </div>
                    <div className={styles.titleCont}>零售和电子商务 </div>
                    <div className={styles.pCont}>
                        <p> 当您选择向Lenovo下订单时，我们可能会收集您的个人信息。这可能包括您的姓名、电子邮箱地址、帐单和发货地址、电话号码、付款信息（如信用卡或借记卡）、年龄/出生日期、用于个性化某个Lenovo产品或服务的信息，以及在有限情况下（即订单处理严格要求此类信息的情况）包括社会保险号或其他国家/地区识别号。Lenovo使用此信息来帮助处理您的订单，并使我们能够在您的订单出现问题时与您联系。此外，如果您购买了需要服务的产品，您的个人信息可能会被用于获取信用报告（如有必要）。  </p>
                        <p> 我们可能会与参与电子商务和零售履行活动的服务提供商和合作伙伴分享此信息，例如数据托管公司、支付处理商、金融机构、运输公司和无线运营商（如果运营商服务是通过我们的网站订购或激活的）。 </p>
                    </div>
                    <div className={styles.titleCont}>客户服务、质量监控和维修 </div>
                    <div className={styles.pCont}>
                        <p> 一些Lenovo产品和服务支持活动也可能涉及您联系Lenovo或Lenovo联系您的情形，包括通过电话、电子邮件或聊天的方式。请注意，在这些情况下，出于员工培训和质量保证目的，我们可能会对通话录音。为了向您提供您所请求的服务或支持（如根据Lenovo产品保修条款请求技术支持或维修服务），联想客户服务人员还可能收集和访问有关您的个人信息，例如您的用户个人资料、帐户信息、联系信息、Lenovo产品和服务标识符以及有关您如何使用Lenovo产品和服务的信息。  </p>
                        <p> 一些联想客户服务人员为向Lenovo及其客户提供此类服务的服务提供商工作，并可能在此背景下访问您的相关信息。联想使用数据托管、处理和通信服务提供商（如在线聊天工具）来支持这些活动。  </p>
                        <p> 此外，Lenovo产品的授权Lenovo分销商、经销商或维修提供商也可能访问此处所述的特定客户服务、质量保证和产品信息，以支持您的产品或提供您请求的服务，如您根据Lenovo产品保修请求的维修服务。  </p>
                    </div>
                    <div className={styles.titleCont}>营销、促销、调查和活动 </div>
                    <div className={styles.pCont}>
                        <p> 如果您选择接收来自联想和/或其合作伙伴的营销、广告或促销通讯（例如通过电子邮件或产品内推送通知），或者如果您选择参加活动、竞赛或调查，我们将收集有关您的个人和非个人信息，以协助我们管理这些活动和通讯，或促进您的参与。具体地说，我们可能会收集您的姓名、地址、电子邮箱地址、电话号码、年龄/出生日期、Lenovo产品信息、您的用户个人资料数据以及您选择提供的其他个人信息。我们还可能使用此信息向您发送产品支持通知、公告、新闻稿，以及在适用法律允许的情况下向您发送参与客户满意度调查的邀请。  </p>
                        <p> 联想和选定的服务提供商或合作伙伴（包括营销、广告、调查和活动公司）也可能使用您提供的信息代表我们或者作为Lenovo与该公司之间的联合活动或促销活动的一部分来开展促销、客户满意度或产品支持活动。联想还可能使用数据托管和处理服务提供商来支持这些活动，以及使用外部工具来帮助我们了解更多有关消费者趋势、营销电子邮件打开/点击率等内容的信息。此外，我们可能会从第三方来源（如消费者研究公司）获取数据，以补充我们从您那里收集的信息。有关我们的网站如何使用第三方 Cookie 和相关技术以支持其在线营销和广告活动的更多信息，请参阅下面标题为“Lenovo会将 Cookie、网络信标、分析和相关技术用于网络广告和其他用途吗？”一节 

        您将收到来自Lenovo的交易通讯，如订单确认。您无需订阅即可接收Lenovo营销通讯，以从Lenovo购买产品。您可以选择按照这些通讯中的说明取消订阅；在帐户设置中更改您的偏好设置；也可以通过 privacy@lenovo.com 与我们联系。 

        忠诚度计划  </p>
                        <p> Lenovo可能为其客户提供参与忠诚度计划以获得折扣、优惠券或其他激励的机会。虽然这些计划是完全可选的，从Lenovo购买产品或服务并不需要参与该计划，但如果您选择参与，则需要收集您的某些个人信息。  </p>
                        <p> 为注册和参与Lenovo忠诚度计划而收集的信息可能包括您的姓名、地址、电子邮箱地址、电话号码、年龄/出生日期、Lenovo产品信息、用户个人资料数据以及您选择提供的其他个人信息。这些信息可能会与Lenovo的服务提供商或合作伙伴分享，以便其代表我们管理忠诚度计划。Lenovo还可能会使用数据托管和处理服务提供商来支持这些活动。您可以按照适用的忠诚度计划规则设定的任何步骤结束您对Lenovo忠诚度计划的参与。 </p>
                    </div>
                    <div className={styles.titleCont}>社交媒体  </div>
                    <div className={styles.pCont}>
                        <p> 我们的一些网站包括社交媒体功能和链接，例如含有图标的社交媒体工具栏，这些图标链接到Lenovo在特定网站上的内容（例如 Facebook 上的Lenovo页面以及 Twitter 上的Lenovo信息流）。这些功能可能会收集您的 IP 地址以及关于您正在访问我们网站上的哪个页面的信息，并且可能会设置 Cookie 来让该功能正常运行。社交媒体功能和小部件由另一家公司托管或者直接在我们的网站上托管。您与这些功能的互动受提供功能的公司的隐私政策约束。  </p>
                        <p>  您可以通过登录各种不同的社交媒体网站（如 Facebook、Google、Twitter 等）来访问某些Lenovo网站体验和帐户信息。如果您选择通过这些服务登录，Lenovo将从您的社交媒体帐户收集某些信息，包括您的公共个人资料、电子邮箱地址、兴趣、爱好及目前所在城市。Lenovo可能会将此类信息链接至或以其他方式包括在您的Lenovo用户个人资料，并且我们还可能将此类信息用于分析和营销目的（如您已选择接收营销通讯）。所提供的信息视您与社交媒体帐户之间达成的隐私设置而定。有关更多详细信息，请参阅适用社交媒体服务的隐私声明。</p>
                    </div>
                    <div className={styles.titleCont}>博客与论坛 </div>
                    <div className={styles.pCont}>
                        <p> 如果您参与Lenovo的博客或论坛，应知晓您在博客或论坛中提供的信息可能会被可以访问该博客、论坛或聊天室的Lenovo内部或外部的其他人广泛使用。此外，请注意各个博客、论坛和聊天室可能是由Lenovo以外的其他组织主办和/或可能有其他的规则和条件。每个参与者在博客、论坛或聊天室发表的意见是他们自己的意见，不应认为是反映了Lenovo的意见。  </p>
                    </div>
                    <div className={styles.titleCont}>客户感言 </div>
                    <div className={styles.pCont}>
                        <p> Lenovo有时会在我们的网站上展示满意客户的产品评述、客户感言和其他代言。我们的服务提供商通常会管理这些评述及相关的网站功能。经您同意，我们可能会连同您的姓名公布您的评论。如果您想更新或删除您的评论，可以通过 privacy@lenovo.com 联系我们。 </p>
                    </div>
                    <div className={styles.titleCont}>就业申请  </div>
                    <div className={styles.pCont}>
                        <p> 当您对联想的就业机会表示兴趣时，您可能会选择向联想提供个人信息，例如通过我们的网站提交申请或简历。我们收集的您的信息将在您提交申请时显示出来，包括姓名、联系信息、背景、教育、就业历史和其他通常用于评估求职者的就业机会的信息。我们将仅使用此信息评估您的就业候选资格，并仅与支持这些活动的服务提供商分享此信息（如代表联想工作的求职者搜索公司和背景筛查公司），以帮助审核求职者的申请。联想可能会使用服务提供商来帮助处理和管理其在此种情况下收集的信息，包括联想业务和公司服务。我们还可能会使用通过公开资源（如 LinkedIn 个人资料）找到的其他信息来作为收到的就业申请的补充信息。  </p>
                    </div>
                    <div className={styles.titleCont}>业务合作伙伴关系  </div>
                    <div className={styles.pCont}>
                        <p> 如果您是Lenovo业务合作伙伴代表（即Lenovo产品的分销商或经销商），您可以访问Lenovo业务合作伙伴专用的Lenovo网站。我们可能会使用您选择通过该网站提供的个人信息来管理和发展我们与您以及您所代表的公司的业务关系。例如，这可能涉及使用您的信息向您发送Lenovo业务合作伙伴计划的详细信息。它可能还包括与其他业务合作伙伴（须遵守可能存在的任何保密义务）、Lenovo客户或潜在客户分享某些信息。对于特定交易或计划，我们也可能在客户满意度调查过程中或出于市场研究目的联系您。用于此目的的信息可能会与帮助我们管理这些网站或关系的服务提供商共享，例如数据托管和处理公司，以及与广告、营销、活动和调查合作伙伴共享，以便他们可以代表我们执行销售、促销活动或调查研究。 </p>
                    </div>
                    <div className={styles.titleCont}>供应商管理  </div>
                    <div className={styles.pCont}>
                        <p> 如果您是Lenovo供应商代表，您可以访问专门面向Lenovo供应商的Lenovo网站。我们可能会在与您达成或履行交易时使用在该网站上提供的信息。 例如，这可能包括与在完成交易所涉及的联想的其他部门、联想的业务合作伙伴、客户、货运公司、金融机构、邮政或政府当局分享信息。 信息还可能会被用于管理和发展我们与您、您所代表的供应商及/或其他Lenovo供应商的关系。 </p>
                    </div>
                    <div className={styles.titleCont}>兼并与收购  </div>
                    <div className={styles.pCont}>
                        <p> 有些时候，出于战略或其他业务原因，Lenovo可能会决定在一些国家或地区出售、收购、兼并或以其他方式重组业务。我们将会通过电子邮件及/或在我们的网站上的显著位置发出通知，告知您的个人信息的所有权或用途的任何变化以及对于您的个人信息而言您可能拥有的任何选择。这种交易可能会涉及向潜在或实际的买方披露个人信息或者从卖方获得个人信息。  </p>
                    </div>
                    <div className={styles.titleCont}>法律要求和行使我们的权利  </div>
                    <div className={styles.pCont}>
                        <p>  个人信息可能要服从于司法或其他政府部门发出的传票、令状、命令或刑事和反欺诈调查的相关安排。因此，如果我们本着善意的原则认为法律有要求，我们可能会向监管或政府机构、法院、审裁处和执法机关披露个人信息或其他信息。我们可能还需要披露个人或其他信息，以保护我们的权利、保护您或他人的安全或对盗窃或欺诈行为进行调查。除上述情况外，可能还会有一些情况要求我们向其他方披露您的个人信息，包括但不限于法律顾问或收债机构。 </p>
                        <p> Lenovo会将 Cookie、网络信标、分析和相关技术用于网络广告和其他用途吗？  </p>
                        <p>  和大多数网站一样，我们会自动收集一些信息并存储在日志文件中。我们有时候会收集关于访客在访问我们网站期间的行为的信息，以帮助我们提供更好的客户服务、改善我们网站体验的质量或者定制广告内容。 </p>
                        <p> 例如，我们会跟踪访客是从哪个域名访问我们的网站，我们也会衡量访客在Lenovo网站上的活动，但是我们在执行上述操作时不会实际识别任何访客的身份（我们将此类信息称为“不可识别身份的信息”）。Lenovo或代表我们的其他方可能会使用此类数据来分析趋势和统计资料，以改进我们的网站以及提供有针对性的广告。  </p>
                    </div>
                    <div className={styles.titleCont}>点击流   </div>
                    <div className={styles.pCont}>
                        <p>  我们在交易中向您收集个人信息时，可能会以不可识别身份的格式提取有关该交易的一些信息并将其与其他不可识别身份的信息结合在一起。此类信息有时称为“点击流”。此类信息仅在汇总层面使用和分析，以帮助我们了解趋势和模式。此类信息不会在个人层面查看。 </p>
                    </div>
                    <div className={styles.titleCont}>Cookie 和在线广告   </div>
                    <div className={styles.pCont}>
                        <p> 为了提供定制的网站体验，Lenovo可能会使用 Cookie 来存储和协助跟踪有关您的信息。在适用法律要求的情况下，Lenovo会在获得您的同意后才在您的Lenovo网站体验期间使用某些 Cookie，及/或为您提供选择启用或禁用哪种类型的 Cookie 的机会。Cookie 只是从 Web 服务器发送到您的浏览器并存储在计算机硬盘驱动器上的一小部分数据。Lenovo使用 Cookie 帮助提醒我们您是谁，并帮助您在访问期间浏览我们的网站。Cookie 使我们能够为您保存偏好设置和购物车内容，以便您不必每次访问时都要重新输入它们。  </p>
                        <p>我们还使用 Cookie 来确定相关的基于兴趣的广告以服务用户。为此，Lenovo可能会使用 Google Analytics for Display Advertisers、Remarketing with Google Analytics、Google Display Network Impression Reporting、DoubleClick Campaign Manager 和 Google Analytics Demographic and Interest Reporting 等公司托管的服务来帮助我们了解客户对我们网站和产品的使用，以及交付和管理基于兴趣的广告。这些服务可能会收集您的浏览器或通过 Cookie 发送的信息，如您的 IP 地址。   </p>
                        <p> 此外，Cookie 和相关技术允许我们：测量网站趋势和流量模式，例如您访问过的Lenovo网站区域和您从哪个网站跳转到此处；简化网站导航；帮助设计我们的网站，以提高网站的使用效率和乐趣；提出产品建议；以及在用户浏览网站（包括非联想网站）时发布Lenovo产品广告。Lenovo及其服务提供商（包括 Google 和 DoubleClick）使用 Cookie 报告您的广告印象、广告服务的其他用途以及与这些广告印象和广告服务的互动与我们网站的访问情况有何关联。如果您不想将此信息用于为您提供基于兴趣的广告，您可以按以下步骤选择退出。您可能会继续收到普通广告。Lenovo还可能会使用从其他来源（包括第三方）获得的信息来补充通过 Cookie 和相关技术收集的信息。  </p>
                        <p> 这类 Cookie 的使用是相对标准化的设置，而大多数浏览器的初始设置都接受此类 Cookie。但是，如果您不想存储 Cookie，您可以选择：  </p>
                        <ul>
                            <li>不使用我们的网站 </li>
                            <li>将浏览器设置为在收到 Cookie 时通知您  </li>
                            <li>将浏览器设置为拒绝接受 Cookie   </li>
                            <li>利用Lenovo网站提供的 Cookie 同意和控制选项（如果可用且适用法律要求）</li>
                            <li>在访问我们的网站后删除 Cookie</li>
                            <li>使用浏览器的匿名使用设置（在 Chrome 中称为 “Incognito”，在 Internet Explorer 中称为 “InPrivate”，在 Firefox 和 Safari 等浏览器中称为 “Private Browsing”）来浏览我们的网站。</li>
                        </ul>
                        <p>但是，请注意，某些Lenovo网站可能不会响应某些浏览器发出的“不要跟踪”信号。您还应了解，如果您不接受 Cookie，Lenovo网站的一些功能可能无法正常运行。</p>
                        <p>如果您不知道如何控制或删除 Cookie，或者希望不要接收基于您的浏览历史记录的某些有针对性的广告，我们建议您访问 www.networkadvertising.org/choices/、www.aboutads.info 或 www.youronlinechoices.eu，了解详细的指导，包括选择退出说明。 </p>
                        <p>如果您想选择退出 Google Analytics for Display Advertisers 和/或选择退出定制的 Google Display Network，可以访问 Google 的 Ads Preferences Manager 来选择退出。您也可以利用 Google Analytics Opt-out Browser Add-on 来选择退出 Google Analytics。关于如何在您的产品或移动设备的浏览器上执行此操作的信息，请参阅您的浏览器或移动设备上的帮助菜单或产品手册。 </p>
                    </div>
                    <div className={styles.titleCont}>本地存储对象   </div>
                    <div className={styles.pCont}>
                        <p> 此外，一些Lenovo网站体验可能使用Lenovo服务提供商和合作伙伴提供的本地存储对象 (LSO)（Flash Cookie 和 HTML5）在您的设备上存储内容信息和偏好设置。各种浏览器可能会提供自己的管理工具来删除 HTML5 LSO。了解如何管理 Flash Cookie。  </p>
                    </div>
                    <div className={styles.titleCont}>Adobe Marketing Cloud Device Cooperative  </div>
                    <div className={styles.pCont}>
                        <p> 某些联想业务和网站参与 Adobe Marketing Cloud Device Cooperative，以更好地了解您如何在您使用的各种设备上使用我们的某些网站和应用程序，以及交付定制的促销内容。了解更多关于 Adobe 如何实施此计划以及您可以如何退出此计划的信息。 </p>
                    </div>
                    <div className={styles.titleCont}>网络信标和其他技术   </div>
                    <div className={styles.pCont}>
                        <p> 一些Lenovo网站还使用网络信标或 JavaScript 和电子标签等其他技术来更好地定制这些网站，以提供更好的客户服务。这些技术可能会在Lenovo网站的多个页面上使用。访客访问这些页面时，将会生成一条不可识别身份的访问通知。我们或我们的服务提供商可能会处理该访问通知。这些网络信标通常与 Cookie 结合工作。如果您关闭 Cookie，网络信标和其他技术仍然会检测对这些页面的访问，但它们生成的通知不能与其他不可识别身份的 Cookie 信息关联，因而会被忽略。  </p>
                    </div>
                    <div className={styles.titleCont}>个性化 URL 链接   </div>
                    <div className={styles.pCont}>
                        <p> 我们有时可能会针对某些访客个性化和定制网站。如果您访问这些网站，您会发现它们是经过定制的，它们含有我们基于您以前与Lenovo的互动以及您提供给我们的信息认为您可能感兴趣的产品及/或服务的参考。在您访问这些网站时，我们可能会收集关于您的访问的信息，以更好地按您的兴趣定制站点。访问这些网站的邀请的显示形式有电子邮件中的个性化 URL、网站注册页面上的通知或者您登录到某个网站时的响应。  </p>
                    </div>
                    <div className={styles.titleCont}>Lenovo是否会出售我的个人信息？  </div>
                    <div className={styles.pCont}>
                        <p>  不会。Lenovo不会出售个人信息。如上节所述，Lenovo可能会与联想、第三方服务提供商和合作伙伴分享个人信息，以便他们支持我们的产品和网站，或向Lenovo及其客户和产品用户提供其他服务。在分享信息时，Lenovo会采取适当步骤来确保这些服务提供商和合作伙伴符合我们严格的隐私和安全标准。但是，Lenovo不会出售个人信息；在 2020 年 12 月 1 日之前的 12 个月内，我们没有出售过任何个人信息。如果Lenovo在任何时候决定出售个人信息，我们将根据适用法律的要求提供适当的事先通知并获取相关方的同意。 </p>
                    </div>
                    <div className={styles.titleCont}>Lenovo会跨国转移我的个人信息吗？   </div>
                    <div className={styles.pCont}>
                        <p>  联想是一个全球性组织，其法律实体、业务流程、管理结构和技术系统遍布全球。因此，在法律允许的情况下，我们可能会在联想内部（包括子公司、附属公司和母公司）或者与我们的服务提供商和业务合作伙伴分享您的个人信息，并且可能会将信息转移到我们开展业务的国家或地区（包括但不限于美国和中国）。无论您的信息被转移到哪里和存放在哪里，我们的隐私和安全做法旨在为您的个人信息提供全球性保护。 </p>
                        <p> 一些国家或地区的隐私法律与您所在国家或地区的隐私法律并不对等，这些司法管辖区的执法机构可能会要求提供您的数据。在这些国家或地区中，联想将仍然以我们在这里描述的方式处理信息，并且在转移和处理您的信息时，将采取为遵守适用的数据保护法律而必要的措施。必要时，联想还将在联想集团公司之间或者与联想合作伙伴或服务提供商签订协议，以管控个人信息的转移、处理和保护。 

        联想使用标准合同条款作为一种手段，帮助实现来自欧盟和欧洲经济区及该地区内部之间的个人信息传输。  </p>
                    </div>
                    <div className={styles.titleCont}>我的个人信息会保留多久？   </div>
                    <div className={styles.pCont}>
                        <p> Lenovo将只在业务或其他令人信服的目的所必需的期限内保留信息，包括个人信息；在满足这些使用目的时将会安全地删除个人信息。只要符合以下任何情况，我们将保留您的信息，包括个人信息： </p>
                        <ul>
                            <li>您的帐户或订阅处于活动状态  </li>
                            <li>为您提供您可能请求的服务或支持   </li>
                            <li>确保Lenovo产品和网站的必要功能和性能，包括我们的产品保修条款规定的责任   </li>
                            <li>遵守适用法律，包括税务和审计目的 </li>
                            <li>行使我们的权利，包括诉讼和债务催收</li>
                        </ul>
                    </div>
                    <div className={styles.titleCont}>如何保护我的信息？   </div>
                    <div className={styles.pCont}>
                        <p> 在我们将信息从我们的网站传输到我们的服务器时、在我们储存数据时以及在我们与第三方分享信息时，我们使用标准的技术和组织措施。例如，在传输敏感信息时，我们使用数据加密来保护您信息的安全。在与第三方分享您的信息时，我们采取合理恰当的步骤确保第三方将负责任地保护和使用您的信息。  </p>
                        <p> 但是，请记住，没有任何产品、软件或数据传输可以保证 100% 安全。因此，虽然我们采取了适当的步骤来保护您的产品和信息，但是Lenovo不能确保或以其他方式担保我们的网站或者您提供给我们的任何信息的安全。使用我们的网站，风险自担。  </p>
                    </div>
                    <div className={styles.titleCont}>如何保护我孩子的隐私？   </div>
                    <div className={styles.pCont}>
                        <p> 我们的网站面向成年人以及年满 16 岁或在相关司法辖区同等最低年龄且使用网站得到家长或法定监护人允许的儿童。Lenovo不会寻求收集关于年龄低于 16 岁的儿童的信息。年龄低于 16 岁的个人不应向Lenovo提供任何信息。  </p>
                        <p> 如果Lenovo获知年龄低于 16 岁或在相关司法辖区同等最低年龄的儿童向Lenovo提交了个人信息，我们将会采取适当的步骤尽快删除该信息且不会将该信息用于任何目的。Lenovo鼓励家长主动监督子女使用互动资源并告知他们提供关于自己的信息的潜在危险。  </p>
                    </div>
                    <div className={styles.titleCont}>我的数据保护权利有哪些？   </div>
                    <div className={styles.pCont}>
                        <p> 适用的数据保护法律可能会赋予您控制我们使用和处理您的个人信息的权利。该等权利可能包括：(i) 要求访问和复印您的个人信息，(ii) 要求更正或清除您的个人信息；(iii) 反对处理您的个人信息；(iv) 限制处理您的个人信息或选择不允许出售您的个人信息；以及 (v) 数据可携性。在我们征得您同意而使用您的个人信息的情况下，您有权随时撤销您的同意，但这并不影响我们在您撤销您的同意之前使用您的个人信息。此外，如果您具有Lenovo帐户，则可以通过该账户查看、更正或删除某些个人信息。  </p>
                        <p> 要行使上述权利，请 联系 privacy@lenovo.com。我们将根据适用的数据保护法律对任何此类请求进行审查、做出响应及采取行动。  </p>
                        <p> 请注意，我们将根据适用法律以及我们的隐私和安全标准采取措施验证您的身份，然后再授权您访问您的个人信息或以其他方式配合您的请求。如果您具有Lenovo帐户，我们可能会要求您登录您的帐户，以此来验证您的身份。如果您没有Lenovo帐户或者我们没有将您的电子邮箱地址存档，我们可能会请求您提供其他有限信息以验证您的身份。请注意，如果您没有Lenovo帐户或没有电子邮箱地址存档，或者我们无法在我们的记录中验证您的身份，我们可能会拒绝您的请求。  </p>
                        <p>  您也可以使用授权代理代表您提交本部分中说明的请求。如果您选择让授权代理代表您提交此类请求，Lenovo需要：(i) 您向授权代理提供允许其代表您提交此类请求的书面许可；(ii) 您的代理直接向Lenovo验证其身份。Lenovo可能会拒绝不符合这些要求的代理提交的请求。</p>
                        <p> 此外，您还有权随时向相关的国家/地区数据保护当局提出问题或投诉。  </p>
                    </div>
                    <div className={styles.titleCont}>如何联系Lenovo隐私计划部门？   </div>
                    <div className={styles.pCont}>
                        <p> 如何联系Lenovo隐私计划部门？ 

        要行使上述权利，或者对本隐私声明有其它疑问，可通过privacy@lenovo.com联系我们，或通过邮政将问题邮寄到如下地址：  </p>
                        <p> 北京市海淀区西北旺东路10号院联想总部西区 法务部 100094  </p>
                        <p> 其他Lenovo客户服务信息，包括电话和聊天联系，可在 www.lenovo.com/contact 上找到。  </p>
                    </div>
                </div>
            </div>
        </React.Antd.Modal>
    )
  }
}
